import React, { useState, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import "chart.js/auto";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Pagination } from "react-bootstrap";
import "./AdmAttendanceDashboard.css";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { ApiUrl } from "../../../ApiUrl";

ChartJS.register(ArcElement, Tooltip, Legend);

const AttendancePage = () => {
  const today = new Date();

  const [chartData, setChartData] = useState([0, 0, 0, 0]);
  const [attendanceCounts, setAttendanceCounts] = useState({
    present: 0,
    absent: 0,
    leave: 0,
    notMarked: 0,
  });

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchAttendanceData = async (date) => {
    const formattedDate = date.toISOString().split("T")[0];
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const academicYearId = localStorage.getItem("academicSessionId");
    const query = `academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}&date=${formattedDate}`;

    try {
      const [summaryResponse, classResponse] = await Promise.all([
        fetch(`${ApiUrl.apiurl}AttendanceDashBoard/dashboard/?${query}`),
        fetch(`${ApiUrl.apiurl}AttendanceDashBoard/dashboardBasedOnClassSection/?${query}`),
      ]);
      if (!summaryResponse.ok || !classResponse.ok) throw new Error("Attendance request failed");
      const [summaryResult, classResult] = await Promise.all([summaryResponse.json(), classResponse.json()]);
      const summary = summaryResult.data || {};
      const counts = {
        present: Number(summary.present_student || 0),
        absent: Number(summary.absent_student || 0),
        leave: Number(summary.leave_student || 0),
        notMarked: Number(summary.not_marked_student || 0),
      };
      setRows(Array.isArray(classResult.data) ? classResult.data : []);
      setCurrentPage(1);
      setChartData([counts.present, counts.absent, counts.leave, counts.notMarked]);
      setAttendanceCounts({
        ...counts,
      });

    } catch (error) {
      console.error("Attendance dashboard error:", error);
      setRows([]);
      setCurrentPage(1);
      setChartData([0, 0, 0, 0]);
      setAttendanceCounts({
        present: 0,
        absent: 0,
        leave: 0,
        notMarked: 0,
      });
    }
  };

  useEffect(() => {
    fetchAttendanceData(selectedDate);
  }, [selectedDate]);

  const pageCount = Math.ceil(rows.length / itemsPerPage);
  const pageRows = rows.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <p className="text-center fw-bold fs-5">Attendance List</p>

              {/*  Pie Chart + Counts Section */}
              <div className="d-flex justify-content-center">
                <div
                  className="attendance-container shadow bg-white p-3 d-flex"
                  style={{ width: "90%", maxWidth: "1000px" }}
                >
                  <div style={{ flex: 1 }}>
                    <div className="d-flex align-items-center flex-wrap justify-content-center mb-3">
                      <label className="me-2 d-flex align-items-center">
                        Date
                        <FontAwesomeIcon
                          icon={faCalendarAlt}
                          className="ms-2"
                        />
                      </label>
                      <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        dateFormat="dd/MM/yyyy"
                        maxDate={today}
                      />
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                      <div style={{ width: "100%", height: "300px" }}>
                        <Pie
                          data={{
                            labels: [
                              "Present",
                              "Absent",
                              "Leave",
                              "Not Marked",
                            ],
                            datasets: [
                              {
                                data: chartData,
                                backgroundColor: [
                                  "#00FF00",
                                  "#FF4D4D",
                                  "#FFA500",
                                  "#C0C0C0",
                                ],
                                borderWidth: 1,
                              },
                            ],
                          }}
                          options={{
                            plugins: {
                              legend: { display: false },
                              tooltip: {
                                callbacks: {
                                  label: (context) => {
                                    const total = context.dataset.data.reduce(
                                      (a, b) => a + b,
                                      0
                                    );
                                    const value = context.raw;
                                    const percentage = (
                                      (value / total) *
                                      100
                                    ).toFixed(1);
                                    return `${context.label}: ${value} (${percentage}%)`;
                                  },
                                },
                              },
                            },
                            maintainAspectRatio: false,
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/*  Attendance Counts */}
                  <div style={{ width: "250px", marginLeft: "20px" }}>
                    <h6 className="fw-bold mb-3">Attendance Summary</h6>
                    <ul className="list-unstyled fs-6">
                      <li className="d-flex align-items-center mb-2">
                        <span
                          style={{
                            width: "14px",
                            height: "14px",
                            backgroundColor: "#00FF00",
                          }}
                          
                          className="me-2 rounded-1"
                        ></span>
                        Present: {attendanceCounts.present}
                      </li>
                      <li className="d-flex align-items-center mb-2">
                        <span
                          style={{
                            width: "14px",
                            height: "14px",
                            backgroundColor: "#FF4D4D",
                          }}
                          className="me-2 rounded-1"
                        ></span>
                        Absent: {attendanceCounts.absent}
                      </li>
                      {/* <li className="d-flex align-items-center mb-2">
                        <span style={{ width: "14px", height: "14px", backgroundColor: "#FFA500" }} className="me-2 rounded-1"></span>
                        Leave: {attendanceCounts.leave}
                      </li> */}
                      <li className="d-flex align-items-center">
                        <span
                          style={{
                            width: "14px",
                            height: "14px",
                            backgroundColor: "#C0C0C0",
                          }}
                          className="me-2 rounded-1"
                        ></span>
                        Not Marked: {attendanceCounts.notMarked}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* :blue_book: Table Section */}
              <div className="row mt-3 mx-2 custom-section-box">
                <div className="d-flex align-items-center mb-2">
                  <label className="me-2 d-flex align-items-center">
                    Date
                    <FontAwesomeIcon icon={faCalendarAlt} className="ms-2" />
                  </label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd/MM/yyyy"
                    className="datepicker"
                    maxDate={today}
                  />
                </div>
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Total Students</th>
                          <th>Present</th>
                          <th>Absent</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(rows) && rows.length > 0 ? (
                          pageRows.map((row, index) => (
                            <tr key={index}>
                              <td>{row.classname}</td>
                              <td>{row.sectionname}</td>
                              <td>{row.total_student}</td>
                              <td>{row.total_present}</td>
                              <td>{row.total_absent}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center text-muted">
                              No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {pageCount > 1 && (
                    <div className="d-flex justify-content-center mt-3">
                      <Pagination className="mb-0">
                        <Pagination.Prev
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage((page) => page - 1)}
                        />
                        {Array.from({ length: pageCount }, (_, index) => (
                          <Pagination.Item
                            active={currentPage === index + 1}
                            key={index + 1}
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next
                          disabled={currentPage === pageCount}
                          onClick={() => setCurrentPage((page) => page + 1)}
                        />
                      </Pagination>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendancePage;